/**
 * How an organization that is not in service is named in a picker.
 *
 * Pending and rejected organizations were listed among the rest with nothing
 * to tell them apart, so an invitation or a group could be aimed at one that
 * was never approved without the reader knowing.
 */

/** A short note for an organization that is not in service; null when it is. */
export function orgStatusNote(status?: string | null): string | null {
  if (status === "pending_approval") return "Pending approval";
  if (status === "rejected") return "Rejected";
  if (status === "suspended") return "Suspended";
  return null;
}

/**
 * Whether an organization belongs in a picker of places to put something. A
 * rejected one is not a place anything can go, so it is left out.
 */
export function isPickableOrg(status?: string | null): boolean {
  return status !== "rejected";
}
